import { RtLoader } from "../RtLoader";
import { AbstractFilters, AbstractRow } from "../RtTypes";
import {
  applyRequest,
  ApplyRequestOptions,
} from "./clientDataCtrl/applyRequest";

export interface RtFullLoader<
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
> extends RtLoader<TRow, TFilters> {
  invalidate(): void;
}

/**
 * Load all table data in one request. But if the data has changed, you can call invalidate to reload it.
 * @param task
 * @param options
 */

export const fullRtLoader = <
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
>(
  task: () => Promise<TRow[]>,
  options?: ApplyRequestOptions<TRow, TFilters>,
): RtFullLoader<TRow, TFilters> => {
  let data: TRow[] | null = null;
  return {
    async load(request) {
      if (!data) {
        data = await task();
      }
      return applyRequest(data ?? [], request, options);
    },
    invalidate() {
      data = null;
    },
  };
};
